/* eslint-disable react/display-name */

import React from 'react';

import { Grid } from '@deliveryhero/pd-cookbook/components/Grid';
import { GridItem } from '@deliveryhero/pd-cookbook/components/GridItem';
import { Form, Formik, FormikHelpers, FormikProps } from 'formik';
import {
  AllowancePayload,
  CompanyDepartments,
  CompanyLocation,
  Department,
  Location,
  User
} from 'services/api';

import { CreateAllowanceName } from './components/CreateAllowanceName';
import { SelectAddresses } from './components/SelectAddresses';
import { SelectEmployees } from './components/SelectEmployees';
import { SelectServiceType } from './components/SelectServiceType';
import { SetAllowanceAmount } from './components/SetAllowanceAmount';
import { SetApplicableDayTime } from './components/SetApplicableDayTime';
import { SetRequireExpenseCode } from './components/SetRequireExpenseCode';
import { allowanceSchema } from './validation';

type AllowanceFormProps = {
  initialValues: AllowanceValuesType;
  handleSubmit: (
    values: AllowanceValuesType,
    actions: FormikHelpers<AllowanceValuesType>
  ) => void;
  locations: Location[];
  departments: Department[];
  users: User[];
  loadingDepartments: boolean;
  loadingUsers: boolean;
  loadingLocations: boolean;
  currency: string;
  searchQuery: string;
  onQuery: (value: string) => void;
};

export type AllowanceValuesType = AllowancePayload & {
  input_budget: string;
  applicable_all_day_time: boolean;
  state: 'active' | 'inactive' | 'deleted' | 'expired';
  editable: boolean;
  company_departments: CompanyDepartments[];
  company_locations: CompanyLocation[];
};

export const AllowanceDetailForm = React.forwardRef<
  FormikProps<AllowanceValuesType>,
  AllowanceFormProps
>((props, ref) => {
  const {
    initialValues,
    handleSubmit,
    locations,
    departments,
    users,
    loadingDepartments,
    loadingLocations,
    loadingUsers,
    currency,
    searchQuery,
    onQuery
  } = props;
  return (
    <div style={{ paddingTop: 5 }}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={allowanceSchema}
        innerRef={ref}
      >
        {(props: FormikProps<AllowanceValuesType>) => (
          <Form>
            <Grid rowGap="16px">
              <GridItem>
                <Grid rowGap="16px">
                  <CreateAllowanceName {...props} />
                  <SetAllowanceAmount {...props} currency={currency} />
                  <SetApplicableDayTime {...props} />
                  <SelectEmployees
                    {...props}
                    departments={departments}
                    users={users}
                    loadingDepartments={loadingDepartments}
                    loadingUsers={loadingUsers}
                    searchQuery={searchQuery}
                    onQuery={onQuery}
                  />
                  <SelectAddresses
                    {...props}
                    locations={locations}
                    loading={loadingLocations}
                  />
                  <SelectServiceType {...props} />
                  <SetRequireExpenseCode {...props} />
                </Grid>
              </GridItem>
              {/* <GridItem>
                <Grid columnGap="16px" style={{ width: '39rem' }}>
                  <SetAllowanceStatus {...props} />
                </Grid>
              </GridItem> */}
            </Grid>
          </Form>
        )}
      </Formik>
    </div>
  );
});
